export const INIT = 'init'
export const RENEW = 'renew'
export const REFRESH = 'refresh'
export const LOGOUT = 'logout'
export const AUTHENTICATE = 'authenticate'
